
(function importProcessDefinition() {
    'use strict';
    angular.module('Entities')
        .service('importProcessService', [
                        'restUrlBuilder', '$injector', '$q', 'config', 'errorsExtend', 'fileService', 'fileDownloader',
            function importProcessService(restUrlBuilder, $injector, $q, config, errorsExtend, fileService, fileDownloader) {

                this.getById = function getById(id) {
                    return restUrlBuilder.one('importProcesses', id).get();
                };
                this.get = function get(selectedImportState, dateFrom, dateTo, typeId, type, page, itemsPerPage, orderby) {
                    var params = { importStateId: selectedImportState != null ? selectedImportState.id : null, dateFrom: dateFrom, dateTo: dateTo, TypeId: typeId, Type: type, Page: page, ItemPerPage: itemsPerPage, OrderBy: orderby };

                    return restUrlBuilder.all('importProcesses')
                        .get({ params: params });
                };


                this.create = function (importProcess, files) {
                    if (importProcess == null)
                        throw 'importProcess no puede ser null';

                    var upload = $injector.get('Upload');

                    if (upload == null)
                        throw "No se pudo instanciar Upload. Verifique que se cargó el script ng-file-upload";

                    return upload.upload({
                        url: config.apiUrl('/importProcesses/'),
                        method: 'POST',
                        fields: { importProcess: JSON.stringify(importProcess) },
                        file: files,
                        fileFormDataName: 'imageFile'
                    });
                };

                this.downloadFile = function (file) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    fileService.download(file.id).then(function (result) {
                        var success = fileDownloader.saveAs(result, file.name);

                        if (!success) {
                            defered.reject('Api failed');
                        }

                        defered.resolve(result);

                    }, function (error) {
                        if (error.status === 204) {
                            defered.reject('The document has not files');
                        } else {
                            defered.reject('Api failed');
                        }
                    });

                    return promise;
                }

                this.downloadErrorFiles = function downloadErrorFiles(document) {
                    var defered = $q.defer();
                    var promise = defered.promise;


                    if (document.files.length == 0) {
                        defered.reject('The import process has not files');
                        return promise;
                    }

                    ///Muestro el ultimo file
                    var file = document.files[document.files.length - 1];

                    return this.downloadFile(file);
                };

            }
        ]);

})();